import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { CiEdit } from 'react-icons/ci';
import { RiGalleryUploadLine } from 'react-icons/ri';

interface datastructure{
  title:string,
  content:string,
  id:number,
  image:string,
  name:String,
}

const RMBLeader = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const [selectedPostId, setSelectedPostId] = useState<string | null>(null);
  const[pagedata, setPagedata] = useState<datastructure[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Open modal
  const openModal = (postId: string) => {
    setSelectedPostId(postId);
    setIsModalOpen(true);
  };

  // Function to close modal and clear the post ID
  const closeModal = () => {
    setSelectedPostId(null);
    setIsModalOpen(false);
  };


  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<datastructure[]>(
          `${api}/auth/rmbLeader`,{
            
      });

        //console.log('rmbLeader data',response.data)
        setPagedata(response.data);
        //console.log("rmbLeader data in a array",pagedata);
      } catch (error) {
        console.error("rmbLeader Not Found:", error);
      }
    };

    fetchData();
  }, []);

  //console.log("rmbLeader data ",pagedata);

  return (
   
    <div>
      <div className='p-6 grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-2'>
        {pagedata.map((item,index)=>(
          <div className='w-full rounded-2xl bg-white p-5 my-2'>
            <div className=''>
              <h1 className='mb-6 text-2xl font-bold'>Section for {item.name}</h1>
               
              

            </div>

            <div className=' flex justify-between items-center flex-row gap-3'>
             {item.image && <img
      className="h-[120px] w-[230px] object-contain rounded-lg"
      src={
        item.image
          ? item.image.startsWith("http")
            ? item.image // Use the full URL if already valid
            : `${api}/${item.image}` // Prepend base URL for relative paths
          : "https://via.placeholder.com/150" // Placeholder image for missing URLs
      }
      alt={item.title || "Image"}
    />}   
            
           <div className='inline-block'>
            <h2 className='text-xl pb-2 font-semibold'>{item.title}</h2>

             <p>{item.content.length > 50 ? item.content.substring(0, 50) + "..." : item.content}</p>
           </div>
            </div>
            <div className='flex w-[130px] justify-center cursor-pointer mt-3  py-2 border border-darkblue  text-darkblue items-center rounded-lg gap-2' onClick={() => openModal(item.id+"")}>
            <CiEdit/>  <h6>Edit section</h6></div>

          </div>



        ))}
        <div>

        </div>

      </div>
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg w-[50%] h-auto">
            {/* Close button */}
            {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
              X
            </button> */}
            <Modal  postId={selectedPostId} onClose={closeModal} />
          </div>
        </div>
      )}
    </div>
  )
}

interface ModalProps {
  postId?: string | null; 
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ postId, onClose }) => {

  const api = process.env.REACT_APP_API_URL as string;
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    image: null as File | null,

  });
  const [fileName, setFileName] = useState<string | null>(null);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    if (postId) {
      const fetchPost = async () => {
        try {
          const response = await axios.get(`${api}/auth/rmbLeader/${postId}`);
  

          const data = Array.isArray(response.data) ? response.data[0] : response.data;
 // Access the first element
  
          // Destructure from the first element of the array
          const { title, content, image: image} = data;
      
  
  //console.log("Title:", title);
  //console.log("Content:", content);
  //console.log("Image:", image);
  setFormData({
    title,
    content,
    image: image || null,
     
  });
  
          setFileName(image);
        } catch (err) {
          console.error('Error fetching post:', err);
        }
      };
      fetchPost();
    }
  }, [postId]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setFormData((prev) => ({ ...prev, image: file }));
    setFileName(file ? file.name : null);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
  
    // Validate fields
    if (!formData.title || !formData.content) {
      setError('All fields are required.');
      return;
    }

  
  
    const data = new FormData();
    data.append('title', formData.title);
    data.append('content', formData.content);
    if (formData.image) {data.append('image', formData.image);}
    
    else if(fileName){
     
      data.append('image',fileName);
    }



    //console.log('rmbLeader data '+formData.image);
    //console.log('filename '+fileName);
  
    // //console.log('Submitting form data:', {
    //   title: formData.title,
    //   content: formData.content,
    //   image: formData.image,
    // });
  
    try {
      if (postId) {
        await axios.put(`${api}/auth/rmbLeader/${postId}`, data, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        //console.log('rmbLeader updated successfully');
      }
      onClose();
      window.location.href  = '/dashboard';
    } catch (err) {
      console.error('Error submitting rmbLeader:', err);
      setError('Failed to submit the rmbLeader. Please try again.');
    }
  };
  

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white lg:w-1/2 w-[90%] p-6 rounded shadow relative">
        
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Title */}
          <div>
            <label className="text-[#030303] font-medium"> Post title</label>
            <div className=" mt-1 w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4 ">
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
             placeholder="Write your post title here..."
                            className="w-full bg-transparent placeholder-[#94A2B8] outline-none text-[14px]"
              required
            />
            </div>
          </div>


          {/* Content */}
          <div>
            <label className="text-[#030303] font-medium">Description</label>
            <textarea
              name="content"
              value={formData.content}
              onChange={handleChange}
              className="mt-1 mb-4 p-2 block w-full h-[150px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
                        placeholder="Write your message here..."
              rows={4}
              required
            />
          </div>

          
          {/* File Upload */}
          <div>
            <label className="text-[#030303]  font-medium">  Add media</label>
            <div className="mt-1 w-[100%] h-[200px] border-dashed px-2 border-[2px] border-[#94A2B8] rounded-lg flex flex-col justify-center items-center mb-4">
           
              <RiGalleryUploadLine size={24} className="text-[30px] cursor-pointer"
                                onClick={() => document.getElementById('file-upload')?.click()}  />
              <input
              id="file-upload"
              type="file"
              accept="image/*"
              className="hidden"
              name='image'
            
              onChange={handleFileChange}

              
            />
            {fileName ? (
  <p className="text-[14px] text-[#02256d] mt-2">
    Selected file: <span className="font-bold">{fileName}</span>
  </p>
) : (
  <p className="font-bold text-[14px]">
    Drag and Drop or{' '}
    <span className="text-[#02256d]">click to upload</span>
  </p>
)}
            </div>
            
          </div>

          {/* Error Message */}
          {error && <p className="text-red-500">{error}</p>}


<div className=' flex justify-between'>

            {/*Cancel form button*/}
            <button className='mt-[22px] mx-[10px] border-[#94A2B8] border px-[20px] py-[10px] rounded-md hover:bg-[#FDBC12] hover:border-none text-[14px] font-bold'  onClick={onClose}>Cancel</button>
             {/* Submit Button */}
          <button
            type="submit"
            className='mt-[22px] bg-[#FDBC12] px-[20px] py-[10px] rounded-md hover:border-[#94A2B8] hover:border hover:bg-[#fdba1200] text-[14px]  cursor-pointer font-semibold'
            disabled={!formData.title || !formData.content}
          >
            {postId ? 'Update Slider' : 'Create Slider'}
          </button>
          </div>
         




          
        </form>
      </div>
    </div>
  );
};

export default RMBLeader